import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { imageContainer, titleContainer } from "./hero.module.css"

const query = graphql`
{
  cover: file(
    base: {eq: "da-dove-veniamo-chi-siamo-dove-andiamo.jpg"},
    sourceInstanceName: {eq: "assets"},
  ) {
    childImageSharp {
      gatsbyImageData(
        layout: FULL_WIDTH,
        transformOptions: {
          cropFocus: NORTH,
          fit: COVER
        },
      )
    }
  }
}
`;

const Hero = ({ title }) => {
  const { cover } = useStaticQuery(query);

  return <section className="relative">
    <GatsbyImage
      image={cover.childImageSharp.gatsbyImageData}
      alt="cover"
      className={imageContainer}
    />
    <div className={`absolute bottom-20 md:top-40 md:right-20 lg:right-40 ${titleContainer}`}>
      <span className="text-white text-5xl md:text-7xl px-4 md:px-6">{title}</span>
      <hr className="h-2 md:h3 w-full bg-yellow border-none" />
    </div>
  </section>;
};

export default Hero;
